function setThumbnailSliderHeight() {
  if (window.innerWidth >= 769) {
    const mainMedia = document.querySelector('.main-product-media-element-inner .product__media-list');
    const thumbnailSlider = document.querySelector('.thumbnail-slider');
    if (mainMedia && thumbnailSlider) {
      const height = mainMedia.offsetHeight;
      thumbnailSlider.style.height = height + 'px';
    }
  } else {
    const thumbnailSlider = document.querySelector('.thumbnail-slider');
    if (thumbnailSlider) {
      thumbnailSlider.style.height = '';
    }
  }
}
window.addEventListener('load', setThumbnailSliderHeight);
window.addEventListener('resize', setThumbnailSliderHeight);
